import styled from 'styled-components';

export const TextLineWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const TextLineLabel = styled.label`
  font-size: 14px;
  font-weight: 400;
  font-family: 'Roboto', sans-serif;
  color: #000;
  min-width: 273px;
  text-align: left;
`;

export const TextLineContent = styled.div`
  font-size: 14px;
  color: #000;
  flex: 1;
  font-family: 'Roboto', sans-serif;
  width: 400px;
  height: 22px;
  display: flex;
  align-items: center;
`;
